import axios from 'axios'

export const fetchFile = (url: string) => axios.get(url, {
  headers: {
    'Content-Type': 'application/json',
  },
})
